import { useEffect } from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from './context/ThemeContext';
import { WidgetProvider } from './context/WidgetContext';
import App from './App.tsx';
import './index.css';
import { initAnalytics, trackPageView } from './analytics';

initAnalytics();

function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => { trackPageView(location.pathname); }, [location]);
  return null;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AnalyticsTracker />
      <ThemeProvider>
        <WidgetProvider>
          <App />
        </WidgetProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);
